// src/components/Gallery.js
import React, { useState } from 'react';
import './Gallery.css';

const imageFolders = [
  { name: 'Studio Moments', path: '/Media/Gallery/Studio/', count: 4 },
  { name: 'Workshops & Events', path: '/Media/Gallery/Workshops/', count: 6 },
  { name: 'Retreat Highlights', path: '/Media/Gallery/Retreat/', count: 35 },
];

const youtubeLinks = [
  'https://www.youtube.com/watch?v=mluMmwfGRxc',
  'https://www.youtube.com/watch?v=ogwqz95gHYY',
  'https://www.youtube.com/watch?v=4KaCBIIPiN0',
  'https://www.youtube.com/watch?v=HhwEE5g8SJ8',
  'https://www.youtube.com/watch?v=8IRFnPcv-JM',
];

function getYoutubeId(url) {
  const match = url.match(/(?:youtu\.be\/|v=)([^&]+)/);
  return match ? match[1] : '';
}

const Gallery = () => {
  const [zoomedImages, setZoomedImages] = useState([]);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [fullscreenVideo, setFullscreenVideo] = useState(null);

  const openGallery = (folder) => {
    // use folder.count to build the right number of images
    const images = Array.from({ length: folder.count }, (_, i) => `${folder.path}${i + 1}.jpg`);
    setZoomedImages(images);
    setActiveImageIndex(0);
  };

  const closeGallery = () => {
    setZoomedImages([]);
    setActiveImageIndex(0);
  };

  const handleArrow = (direction) => {
    setActiveImageIndex((prev) =>
      direction === 'left'
        ? Math.max(0, prev - 1)
        : Math.min(zoomedImages.length - 1, prev + 1)
    );
  };

  return (
    <section className="gallery-section" id="gallery">
      <h2 className="gallery-heading">Our Gallery</h2>

      {/* Image Section */}
      <div className="image-gallery-section">
        {imageFolders.map((folder, idx) => (
          <div
            className="image-gallery"
            key={idx}
            onClick={() => openGallery(folder)}
            title={folder.name}
          >
            <div className="gallery-title">{folder.name}</div>
            <img src={`${folder.path}1.jpg`} alt={folder.name} />
          </div>
        ))}
      </div>

      {/* Zoomed Image Lightbox */}
      {zoomedImages.length > 0 && (
        <div className="lightbox" style={{ zIndex: 9999 }}>
          <button className="close-btn" onClick={closeGallery} style={{ zIndex: 9999 }}>
            ×
          </button>
          {activeImageIndex > 0 && (
            <button className="nav-arrow left" onClick={() => handleArrow('left')}>
              ‹
            </button>
          )}
          <img src={zoomedImages[activeImageIndex]} alt="Zoomed" className="zoomed-image" />
          {activeImageIndex < zoomedImages.length - 1 && (
            <button className="nav-arrow right" onClick={() => handleArrow('right')}>
              ›
            </button>
          )}
        </div>
      )}

      {/* YouTube Section (unchanged) */}
      <h2 className="gallery-heading">Our YouTube Videos</h2>
      <div className="video-scroller">
        <div className="video-container">
          {youtubeLinks.map((url, idx) => (
            <div
              key={idx}
              className="video-thumbnail"
              onClick={() => setFullscreenVideo(`https://www.youtube.com/embed/${getYoutubeId(url)}`)}
            >
              <img
                src={`https://img.youtube.com/vi/${getYoutubeId(url)}/0.jpg`}
                alt={`YouTube Thumbnail ${idx + 1}`}
              />
              <div className="play-icon">▶</div>
            </div>
          ))}
        </div>
      </div>

      {fullscreenVideo && (
        <div className="fullscreen-video" style={{ zIndex: 9999 }}>
          <span className="close-btn" onClick={() => setFullscreenVideo(null)} style={{ zIndex: 9999 }}>
            ×
          </span>
          <iframe
            src={`${fullscreenVideo}?autoplay=1`}
            title="fullscreen-player"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
